import { type NetworkPlacement } from "./types";

export const getDefaultSetting = (settings: NetworkPlacement.Setting[]): NetworkPlacement.Setting | null => {
  if (!settings.length) return null;

  return settings[0];
};
